/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiSyncFromJSON, ApiSyncToJSON, } from './ApiSync';
import { ApiSyncTypeFromJSON, ApiSyncTypeToJSON, } from './ApiSyncType';
import { ApiUserFromJSON, ApiUserToJSON, } from './ApiUser';
export function ApiUserOauthClientFromJSON(json) {
    return ApiUserOauthClientFromJSONTyped(json, false);
}
export function ApiUserOauthClientFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'readyToTypes': !exists(json, 'readyToTypes') ? undefined : (json['readyToTypes'].map(ApiSyncTypeFromJSON)),
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'syncs': !exists(json, 'syncs') ? undefined : (json['syncs'].map(ApiSyncFromJSON)),
        'user': !exists(json, 'user') ? undefined : ApiUserFromJSON(json['user']),
    };
}
export function ApiUserOauthClientToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'externalId': value.externalId,
        'id': value.id,
        'readyToTypes': value.readyToTypes === undefined ? undefined : (value.readyToTypes.map(ApiSyncTypeToJSON)),
        'scopes': value.scopes,
        'service': ApiServiceToJSON(value.service),
        'syncs': value.syncs === undefined ? undefined : (value.syncs.map(ApiSyncToJSON)),
        'user': ApiUserToJSON(value.user),
    };
}
